import { documentStatus } from "../constants/statusConstants";
import {
  BASE_DEVELOPMENT_URL,
  BASE_PRODUCTION_URL,
  BASE_UAT_URL,
  Environment,
  Page,
} from "../constants";

const getEnv = (key: string) => process.env[key] || "";

const getURL = (subURL: string) => {
  return `${getEnv("REACT_APP_GRAPH_API_URL")}${subURL}`;
};
const getBetaURL = (subURL: string) => {
  return `${getEnv("REACT_APP_GRAPH_API_BETA_URL")}${subURL}`;
};

const getListIdByStatusValue = (status: string | null, isOpen: boolean = false) => {
  if (status === documentStatus.publish.value || isOpen) {
    return `${getEnv("REACT_APP_PUBLIC_FOLDER_AND_FILE_SP_LIST_ID")}`;
  }
  return undefined;
};

const getInfoListIdByStatusValue = (status: string, isOpen: boolean) => {
  if (status === documentStatus.publish.value || isOpen) {
    return `${getEnv("REACT_APP_WORKING_DOCS_PUBLISH_INF_LIST_ID")}`;
  }
  return undefined;
};
const environment = process.env["REACT_APP_ENV"] as Environment;
export const isProduction = environment === Environment.production;

const getBaseURL = (): string => {
  switch (environment) {
    case Environment.development:
      return BASE_DEVELOPMENT_URL;
    case Environment.production:
      return BASE_PRODUCTION_URL;
    case Environment.uat:
      return BASE_UAT_URL;
    default:
      return BASE_DEVELOPMENT_URL;
  }
};

const getPageURL = (page: Page): string => {
  const baseURL = getBaseURL();
  switch (page) {
    case Page.applicationForLeave:
      return `${baseURL}/procedure/absence-letter`;
    case Page.monthlyTrainingPlan:
      return `${baseURL}/procedure/monthly-training-plan`;
    case Page.monthlyTrainingPlanSummary:
      return `${baseURL}/procedure/monthly-training-plan-summary`;
    case Page.businessCard:
      return `${baseURL}/procedure/business-card`;
    default:
      return "";
  }
};

const getGraphURL = (page: Page): string => {
  const baseGraphURL = getEnv("REACT_APP_GRAPH_API_URL");
  const siteId = getEnv("REACT_APP_SP_SITE_ID");
  if (page === Page.applicationForLeave) {
    const listId = getEnv("REACT_APP_APPLICATION_FOR_LEAVE_LIST_ID");
    return `${baseGraphURL}/sites/${siteId}/lists/${listId}/items`;
  }
  if (page === Page.monthlyTrainingPlan) {
    const listId = getEnv("REACT_APP_TRAINING_COURSE_MONTHLY_LIST_ID");
    return `${baseGraphURL}/sites/${siteId}/lists/${listId}/items`;
  }
  if (page === Page.monthlyTrainingPlanSummary) {
    const listId = getEnv("REACT_APP_MONTHLY_TRAINING_PLAN_SUMMARY_SP_LIST_ID");
    return `${baseGraphURL}/sites/${siteId}/lists/${listId}/items`;
  }
  if (page === Page.businessCard) {
    const listId = getEnv("REACT_APP_BUSINESS_CARD_REQUEST_LIST_ID");
    return `${baseGraphURL}/sites/${siteId}/lists/${listId}/items`;
  }
  return "";
};

export {
  getURL,
  getBetaURL,
  getListIdByStatusValue,
  getInfoListIdByStatusValue,
  getPageURL,
  getGraphURL,
};
